import { ThisConnector } from '../../../../api/connector'
import { BaseApiResponse } from '../../../../api/shared'
import {
  ExclusionApiResponse,
  ExclusionRequestArgs,
  ExclusionRequest,
  normalizeExclusionRequest
} from './shared'

export interface UpdateAppExclusionArgs extends ExclusionRequestArgs {
  exclusion: ExclusionRequest
}

export async function updateApplicationExclusion(
  this: ThisConnector,
  {
    organizationUuid,
    applicationId,
    exclusionId,
    exclusion
  }: UpdateAppExclusionArgs
): Promise<BaseApiResponse> {
  const { messages, success } = await this.connector.put<ExclusionApiResponse>(
    `/${organizationUuid}/applications/${applicationId}/exclusions/${exclusionId}?expand=skip_links`,
    normalizeExclusionRequest(exclusion)
  )

  return {
    success,
    messages
  }
}
